<template>
  <div class="container-fluid d-flex align-items-center justify-content-center vh-100">
    <div class="w-100">
        <div class="row justify-content-center">
            <div class="col-3 my-3 text-center">
                <img width="300" src="../assets/health-here-logo.svg"/>
            </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-3">
            <div class="alert alert-info" role="alert" v-show="message">
                <div>{{ message }}</div>
            </div>
            <div class="alert alert-danger" role="alert" v-show="errors.length > 0">
                <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-3">
                <form class="form-horizontal">
                    <div class="form-group">
                        <label for="inputEmail3" class="control-label">Email</label>
                        <div class="">
                            <input type="email" v-model="emailAddress" class="form-control" id="inputEmail3" placeholder="Email">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="">
                            <button type="submit" @click.prevent="submit()" class="btn btn-orange btn-block">E-Mail Reset Link</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
  import api from '../services/api'

  export default {
    name: 'ForgotPassword',

    props: {
      email: {
        type: String,
        required: false
      }
    },

    data () {
      return {
        emailAddress: this.email,
        errors: [],
        message: ''
      }
    },

    methods: {
      submit () {
        this.errors = []
        this.message = ''
        const credentials = {
          email: this.emailAddress
        }

        api.post('/Auth/ForgotPassword', credentials).then(response => {

          this.message = 'Check your email for a link to setup a new password'

        }, errorResponse => {
          if (errorResponse.response) {
            this.errors = errorResponse.response.data.login_failure
          } else {
            this.errors = [errorResponse.message]
          }
        })

      }
    }
  }
</script>

<style scoped>

</style>
